import { Role } from '@/types/types';
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

const trueRoleSlice = createSlice({
    name: 'trueRole',
    initialState: 'cutomer' as Role,
    reducers: {
        trueRoleSet: (_state, action: PayloadAction<Role>) => {
            return action.payload;
        }
    }
})

export const { trueRoleSet } = trueRoleSlice.actions;
export default trueRoleSlice.reducer;
